var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrURLInput',{staticClass:"click-url",attrs:{"rules":_vm.rules,"label":"Click URL","maxlength":"2048","required":_vm.isRequired,"secure-url":"","disabled":_vm.isDisabled},on:{"input":_vm.onValueChange,"update:error":_vm.onError},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }